import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Header from '../layouts/Header';
import Breadcrumb from '../layouts/Breadcrumbs';
import Footer from '../layouts/Footertwo';
import PrivacyContent from '../sections/privacy/Content';

class Privacy extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Joyería Bacelis</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header logoOnly />
                <div className="breadcrumb-bacelis">
                    <Breadcrumb breadcrumb={{ pagename: 'Joyería Bacelis' }} hideTrail />
                </div>
                <PrivacyContent />
                <Footer />
            </Fragment>
        );
    }
}

export default Privacy;
